import {create} from "zustand";

export interface IInvoice {
    text: string;
    amount: any;
    exonerated?: boolean;
    id?: number;
  }

interface InvoiceState {
    formData: Record<string, any>;
    setFormData: (formData: Record<string, any>) => void;

    isCreatingOrUpdating: boolean;
    setIsCreatingOrUpdating: (isCreatingOrUpdating: boolean) => void;

    tabInvoice: string;
    setTabInvoice: (tabInvoice: string) => void;

    detailCustomer: any;
    setDetailCustomer: (detailCustomer: any) => void;

    detailsInvoice: IInvoice[];
    setDetailsInvoice: (detailsInvoice: IInvoice[]) => void;

    proformas: any[];
    setProformas: (proformas: any[]) => void;

    invoices: any[];
    setInvoices: (invoices: any[]) => void;

    idsProformasSelected: number[];
    setIdsProformasSelected: (idsProformasSelected:  number[] | ((prev:  number[]) =>  number[])) => void;

    idProformaSelected: number;
    setIdProformaSelected: (idProformaSelected: number) => void;

    viewOrUpdate : string;
    setViewOrUpdate: (viewOrUpdate: string) => void;

    updateProforma: boolean;
    setUpdateProforma: (updateProforma: boolean) => void;

    creditNotes: any[];
    setCreditNotes: (creditNotes: any[]) => void;

    dataFilterProformas: any[];
    setDataFilterProformas: (dataFilterProformas: any[]) => void;

    dataFilterInvoices: any[];
    setDataFilterInvoices: (dataFilterInvoices: any[]) => void;

    dataFilterCreditNotes: any[];
    setDataFilterCreditNotes: (dataFilterCreditNotes: any[]) => void;

    invoiceDetails: any;
    setInvoiceDetails: (invoiceDetails: any) => void;

    totalHT: number;
    setTotalHT: (totalHT: number) => void;

    totalTTC: number;
    setTotalTTC: (totalTTC: number) => void;

    totalSold: number;
    setTotalSold: (totalSold: number) => void;

    resetInvoice: () => void;
}

export const useInvoiceStore = create<InvoiceState>((set) => ({
    formData: {},
    setFormData: (formData) => set({formData}),

    isCreatingOrUpdating: false,
    setIsCreatingOrUpdating: (isCreatingOrUpdating) => set({isCreatingOrUpdating}),

    tabInvoice: 'Factures',
    setTabInvoice: (tabInvoice) => set({tabInvoice}),

    detailCustomer: {},
    setDetailCustomer: (detailCustomer) => set({detailCustomer}),

    detailsInvoice: [{text: "", amount: 0}],
    setDetailsInvoice: (detailsInvoice) => set({detailsInvoice}),

    proformas: [],
    setProformas: (proformas) => set({proformas}),

    viewOrUpdate: '',
    setViewOrUpdate: (viewOrUpdate) => set({viewOrUpdate}),

    idsProformasSelected: [],
    setIdsProformasSelected: (update: any[] | ((prev: any[]) => any[])) =>
        typeof update === 'function' ? set((state) => ({ idsProformasSelected: update(state.idsProformasSelected) }))
                                     : set({ idsProformasSelected: update }),
                                     
    idProformaSelected: 0,
    setIdProformaSelected: (idProformaSelected) => set({idProformaSelected}),

    updateProforma: false,
    setUpdateProforma: (updateProforma) => set({updateProforma}),

    invoices: [],
    setInvoices: (invoices) => set({ invoices }),

    creditNotes: [],
    setCreditNotes: (creditNotes) => set({creditNotes}),

    dataFilterProformas: [],
    setDataFilterProformas: (dataFilterProformas) => set({dataFilterProformas}),

    dataFilterInvoices: [],
    setDataFilterInvoices: (dataFilterInvoices) => set({dataFilterInvoices}),

    dataFilterCreditNotes: [],
    setDataFilterCreditNotes: (dataFilterCreditNotes) => set({dataFilterCreditNotes}),

    invoiceDetails: {},
    setInvoiceDetails: (invoiceDetails) => set({invoiceDetails}),

    totalHT: 0,
    setTotalHT: (totalHT) => set({totalHT}),

    totalTTC: 0,
    setTotalTTC: (totalTTC) => set({totalTTC}),

    totalSold: 0,
    setTotalSold: (totalSold) => set({totalSold}),

    resetInvoice: () => set({formData: {}, isCreatingOrUpdating: false, proformas: [], idProformaSelected: 0,viewOrUpdate: '', idsProformasSelected: [], detailsInvoice: [{text: "", amount: 0}], detailCustomer: {}, invoices: [], invoiceDetails: {},  creditNotes: [], totalHT: 0, totalTTC: 0, totalSold: 0}),
}));